import React, {Component} from 'react'
import { render } from 'react-dom'
import { Provider, connect } from 'react-redux'

import ShippingSelectorRoot from './roots/shipping_selector_root'
import CheckoutOrderTotal from './roots/checkout_order_total'

import CartItemQuantity from './components/cart_item_quantity'
import TileAddToCart from './components/tile_add_to_cart'
import AddressEditor from './components/address_editor'
import GlobalSearchAutoSuggest from './components/global_search_auto_suggest'
import ProductLightbox from './components/product_lightbox'

export {ShippingSelectorRoot, CheckoutOrderTotal, CartItemQuantity, TileAddToCart, AddressEditor, GlobalSearchAutoSuggest, ProductLightbox}



// WEBPACK FOOTER //
// ./app/javascript/store_front/app/index.js